export function _debounce(fn, delay) {
  var delay = delay || 600;
  var timer;
  let flag = true;
  return function(th, args) {
    var th = this;
    var args = arguments;

    if (flag) {
      fn.apply(th, args);
      flag = false;
    }
    clearTimeout(timer);
    timer = setTimeout(function() {
      flag = true;
    }, delay);
  };
}
